import {
  Chip,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Menu,
  MenuItem,
} from "@material-ui/core";
import React from "react";
import { User } from "../../../graphql/baseTypes";

interface Props {
  item: User;
  isLast?: boolean;
  changeUserRoles: (username: string) => any;
  changeUserState: (username: string, state: "Enabled" | "Disabled") => any;
  changeUserPassword: (username: string) => any;
}

const UserListItem: React.FC<Props> = ({
  item,
  isLast,
  changeUserRoles,
  changeUserState,
  changeUserPassword,
}) => {
  const { username, groups, state } = item;
  const [anchorEl, setAnchorEl] = React.useState(null);

  const _handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
    event.stopPropagation();
  };
  const _handleRoleChange = () => {
    changeUserRoles(username);
  };
  const _handleClose = () => {
    setAnchorEl(null);
  };
  const _handleChangeUserState = () => {
    changeUserState(username, state ? state : "Enabled");
    _handleClose();
  };
  const _handleChangePassword = () => {
    changeUserPassword(username);
  };
  return (
    <ListItem
      divider={!isLast}
      button
      role={undefined}
      onClick={_handleRoleChange}
    >
      <ListItemText primary={username} />
      <ListItemText primary={groups} />
      <ListItemSecondaryAction>
        <Chip
          size="small"
          label={state !== "Enabled" ? "Deaktiviert" : "Aktiviert"}
          onClick={_handleClick}
        />
        <Menu
          id="user-menu"
          anchorEl={anchorEl}
          keepMounted
          getContentAnchorEl={null}
          variant="menu"
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          open={Boolean(anchorEl)}
          onClose={_handleClose}
        >
          <MenuItem onClick={_handleChangeUserState}>
            {state === "Enabled" ? "Deaktivieren" : "Aktivieren"}
          </MenuItem>
          <MenuItem onClick={_handleChangePassword}>Passwort setzten</MenuItem>
        </Menu>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default UserListItem;
